import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import call from "../../shared/services/api-service";
import { getFirstStringError } from "../../shared/utils/general.utils";
import { removeUser } from "../../shared/services/auth-service";


const postEditLead= createAsyncThunk(
    "phoneConfirmation/postEditLead", 
    async(values:any): Promise<any>=>{
    try {
        var {onSuccessCallback, ...data} = values;
        await call({
            path: `/api/v1/lead/uber/public/update`,
            method: "POST",
            data
        },"core");
        if(typeof onSuccessCallback === "function"){
            onSuccessCallback();
        }
        return data?.captain_mobile;
    } catch (error) {
        message.error(getFirstStringError(error));
        return;
    }
});
const postConfirmOtpCode= createAsyncThunk("phoneConfirmation/postConfirmOtpCode", async(values:any): Promise<any>=>{
    try {
        const {onsuccessCallback, ...data} = values
        const result = await call({
            path: `/api/v1/lead/uber/public/verify`,
            method: "POST",
            data
        },"core");
        if(result){
            removeUser();
            if(typeof onsuccessCallback === "function"){
                onsuccessCallback(result);
            }
            return {message: result?.message?? "Thank you! We will keep in touch with you very soon." };
        }
    } catch (error) {
        message.error(getFirstStringError(error));
        return;
    }
});
export {
    postConfirmOtpCode,
    postEditLead
}